"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceHeaderMetadataProject = void 0;
const tslib_1 = require("tslib");
const catalog_messages_1 = require("@tableau/catalog-messages");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const react_1 = tslib_1.__importDefault(require("react"));
/**
 * Renders a project link, formatted for use in the place page header
 * @param props
 */
function PlaceHeaderMetadataProject(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: data_catalog_shared_1.placeHeaderMetadataLabelClass }, catalog_messages_1.Messages.Project()),
        react_1.default.createElement("a", { href: props.siteUrls.projectUrl(props.projectId), target: '_blank', className: (0, data_catalog_shared_1.classes)(data_catalog_shared_1.placeHeaderMetadataLinkClass, data_catalog_shared_1.placeHeaderMetadataValueClass), title: props.projectName, rel: 'noreferrer' }, props.projectName)));
}
exports.PlaceHeaderMetadataProject = PlaceHeaderMetadataProject;
//# sourceMappingURL=PlaceHeaderMetadataProject.js.map